/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLockAvatar.vue?vue&type=template&id=6312563b"
import script from "./popLockAvatar.vue?vue&type=script&lang=js"
export * from "./popLockAvatar.vue?vue&type=script&lang=js"
import style0 from "./popLockAvatar.vue?vue&type=style&index=0&id=6312563b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports